<div
  class="body ui container"
  fxLayout="column"
  style="margin: 0; border: none !important; width: 100%"
>
  <div
    class="ui divider"
    appMargin
    marginY="3"
    style="border: none !important"
  ></div>
  <div *ngIf="success || error">
    <esl-message-toast
      [(message)]="success"
      [messageType]="'success'"
    ></esl-message-toast>
    <esl-message-toast [(message)]="error"></esl-message-toast>
  </div>
  <app-advanced-search-filter
    (onDisplayRows)="displayRecords($event)"
    (onSearch)="searchRecords($event)"
    [hasAdvancedSearch]="true"
    [headers]="headers"
    [headerFilters]="headerFilters"
    [hasFilters]="true"
    (onSort)="sortRecords($event)"
    [searchFilters]="searchFilter"
    (advancedSearch)="advancedSearch($event)"
    (cancelAd)="cancelAd()"
  ></app-advanced-search-filter>

  <div class="ui vertical basic segment" [ngClass]="{ loading: pending }">
    <div
      fxLayout="row"
      tamsyMargin
      class="ui segment"
      marginB="3"
      fxLayoutGap="10px"
      fxLayoutAlign="start stretch"
      id="dark"
    >
      <div fxFlex="15%">Country</div>
      <div fxFlex="15%">Rate Limit</div>
      <div fxFlex="10%">Time Interval</div>
      <div fxFlex="30%">Response</div>
      <div fxFlex="10%">Created By</div>
      <div fxFlex="10%">Date Created</div>
      <div fxFlex="10%"></div>
    </div>

    <div
      class="ui attached segment"
      appMargin
      marginT="5"
      *ngFor="let globalRateLimitSetting of globalRateLimitSettings"
    >
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
        <div fxFlex="15%">
          {{ globalRateLimitSetting?.country }}
        </div>
        <div fxFlex="15%">{{ globalRateLimitSetting?.quota }} requests</div>
        <div fxFlex="10%">
          {{ globalRateLimitSetting?.interval }}
          {{ globalRateLimitSetting?.interval > 1 ? "seconds" : "second" }}
        </div>
        <div fxFlex="30%">
          {{ globalRateLimitSetting?.responseMessage }}
        </div>

        <div fxFlex="10%">
          {{ parseItem(globalRateLimitSetting?.createdBy)?.username || "-" }}
        </div>

        <div fxFlex="10%">
          {{
            globalRateLimitSetting?.dateCreated | date: "dd MMM, yyyy, h:mm a"
          }}
        </div>
        <div fxFlex="10%">
          <div class="icons">
            <img
              src="assets/icons/edit-sm.svg"
              alt=""
              (click)="editGlobalRateLimit(globalRateLimitSetting)"
              *ngIf="
                checkPermission({
                  id: 'APPLICATION_SECURITY_MODULE',
                  action: 'edit'
                })
              "
            />
            <img
              src="assets/icons/delete-sm.svg"
              alt=""
              (click)="deletGlobalRateLimit(globalRateLimitSetting)"
              *ngIf="
                checkPermission({
                  id: 'APPLICATION_SECURITY_MODULE',
                  action: 'remove'
                })
              "
            />
          </div>
        </div>
      </div>
    </div>

    <!-- <app-no-record-found
        *ngIf=""
      ></app-no-record-found>
      <app-no-record-found *ngIf="!logs"></app-no-record-found> -->

    <div class="ui vertical basic segment">
      <div class="ui two column grid">
        <div class="column middle aligned">
          <div class="ui icon button">
            <i class="database icon"></i>
          </div>
          <a class="ui basic label">{{ totalItems }} Record(s)</a>
        </div>
        <div
          class="column right aligned pagination menu"
          style="margin-left: auto"
        >
          <sui-pagination
            class="small"
            [collectionSize]="totalItems"
            [pageSize]="rows"
            [maxSize]="maxSize"
            [hasEllipses]="false"
            [page]="currentPage"
            (pageChange)="nextPage($event)"
          >
          </sui-pagination>
        </div>
      </div>
    </div>
  </div>
</div>
